// components/SocioSwiftModal.tsx
import { useFetcher, useLoaderData } from '@remix-run/react';
import { useEffect, useRef, useState } from 'react';
import { DialogFooter } from '~/design-system/primitives';
import { Button, Dialog, DialogContent, Modal } from '~/design-system/primitives';
import Checkbox, { CheckboxGroup } from '~/design-system/primitives/CheckBox';
import { Close } from '~/icons';
import SocioSvg from '~/icons/Socio';
import { Profile } from '~/type/User';
import type { loader } from '~/routes/myaccount';

interface SocioSwiftModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SocioSwiftModal({ isOpen, onClose }: SocioSwiftModalProps) {
  if (!isOpen) return null;

  const [swiftVcChecked, setSwiftVcChecked] = useState(true);

  const { user } = useLoaderData<typeof loader>();
  const fetcherSend = useFetcher();
  const userData = user?.profile as Profile;

  const currentConsents = user?.profile?.consents?.reduce((acc, consent) => {
    acc[consent.key] = consent.value;
    return acc;
  }, {} as Record<string, boolean>);

  const isLoading = fetcherSend.state !== 'idle';

  const prevState = useRef(fetcherSend.state);
  console.log(console.log(fetcherSend.state))

  useEffect(() => {
    if (fetcherSend.data) {
      window.location.reload();
    }
  }, [fetcherSend.data]);

  function handleOptIn() {
    if (userData) {
      const formData = new FormData();
      formData.append('firstName', userData.firstName);
      formData.append('lastName', userData.lastName);
      formData.append('email', userData.email);
      formData.append('document', userData.document);
      formData.append('phone', userData.phone);
      formData.append('dateOfBirth', userData.dateOfBirth);
      formData.append('gender', userData.gender);
      formData.append('actionType', 'updateUserPf');
      formData.append('swift_vc', swiftVcChecked ? 'true' : 'false');
      formData.append('politica_privacidade', currentConsents?.politica_privacidade ? 'true' : 'false');
      formData.append('swiftEvoceComunicacao', currentConsents?.swiftEvoceComunicacao ? 'true' : 'false');
      fetcherSend.submit(formData, { method: 'post', action: '/myaccount' });
    }
  }

  return (
    <>
      <Modal className="bg-transparent max-w-[18.5rem]" isOpen={isOpen}>
        <Dialog className="bg-white rounded-md max-w-[1080px] pt-2.5 pr-5 pl-7">
          <DialogContent className="pt-3 relative">
            <button
              className="absolute top-4 right-0 border-0 bg-transparent"
              type="button"
              onClick={() => onClose()}
            >
              <Close />
            </button>

            <div className="flex flex-col w-full mb-1">
              <SocioSvg width="67px" height="24px" />
              <div className="border-b-2 border-gray-40 p-0 w-full pb-3" />
            </div>

            <div className="flex flex-col w-full gap-5 mt-4">
              <p className="text-sm font-medium">
                Com o Sócio Swift, você ganha R$5,00 de cashback a cada R$100,00 em compras.
              </p>

              <CheckboxGroup
                defaultValue={['swift_vc', 'swiftEvoceComunicacao']}
                className="my-2"
                aria-labelledby="cashback-label"
              >
                <Checkbox
                  id="cashback-checkbox"
                  value="swift_vc"
                  isSelected={swiftVcChecked}
                  aria-describedby="cashback-description"
                  onChange={setSwiftVcChecked}
                >
                  <label
                    htmlFor="cashback-checkbox"
                    id="cashback-label"
                    className="table text-sm text-gray-100"
                  >
                    Aceito participar do programa Sócio Swift
                  </label>
                </Checkbox>
              </CheckboxGroup>
            </div>

            <DialogFooter>
              <Button
                className="w-full border-gray-40"
                isDisabled={isLoading}
                onPress={handleOptIn}
                isOutlined
              >
                Confirmar
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </Modal>
    </>
  );
}
